import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const UnknownDevice = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.3"
            d="M10.1226 3C11.3706 3 12.3726 3.342 13.1286 4.026C13.8966 4.698 14.2806 5.628 14.2806 6.816C14.2806 7.992 13.9026 8.892 13.1466 9.516C12.3906 10.128 11.3886 10.434 10.1406 10.434L10.0686 11.82H7.85464L7.76464 8.76H8.57464C9.61864 8.76 10.4226 8.622 10.9866 8.346C11.5506 8.07 11.8326 7.566 11.8326 6.834C11.8326 6.306 11.6766 5.886 11.3646 5.574C11.0646 5.262 10.6506 5.106 10.1226 5.106C9.57064 5.106 9.13864 5.256 8.82664 5.556C8.52664 5.856 8.37664 6.27 8.37664 6.798H6.00064C5.98864 6.066 6.14464 5.412 6.46864 4.836C6.79264 4.26 7.26664 3.81 7.89064 3.486C8.52664 3.162 9.27064 3 10.1226 3ZM8.95264 16.122C8.49664 16.122 8.11864 15.984 7.81864 15.708C7.53064 15.42 7.38664 15.066 7.38664 14.646C7.38664 14.226 7.53064 13.878 7.81864 13.602C8.11864 13.314 8.49664 13.17 8.95264 13.17C9.39664 13.17 9.76264 13.314 10.0506 13.602C10.3386 13.878 10.4826 14.226 10.4826 14.646C10.4826 15.066 10.3386 15.42 10.0506 15.708C9.76264 15.984 9.39664 16.122 8.95264 16.122Z"
            fill="currentColor"
          />
        </SVGIconRender>
  );
};

export default UnknownDevice;
